<template>
  <div :class="$style.summary" v-if="model">
    <Summary
      :model="model"
      :class="$style.content"
      @close="close"
      @showBind="showBind"
      @redirectFloatPage="redirectFloatPage"
      :isSuspend="isSuspend"
      v-show="!giftVisible"
      @showGift="showGift"
    ></Summary>
    <!-- 绑定手机组件 -->
    <div :class="$style.bind" v-if="bindVisible">
      <Bind @back="closeBind" :fullScreenFlag="true"></Bind>
    </div>
    <div :class="$style.bindMask" v-if="giftVisible">
      <Gift @close="closeGift" :giftId="giftId" :giftType="giftType"></Gift>
    </div>
  </div>
</template>

<script>
import Summary from "@/components/activity/Summary"
import Bind from '@/components/login/BindPhone'
import Gift from '@/components/activity/Gift.vue'
import { mapState } from "vuex"
import { registHiddenRedDotFunction, registReturnGameFunction, openFloatBall } from '@/bridge/AppJsBridge'
import { getStorage } from "@/libs/utils"
import { versionCompare } from '@/libs/utils.js';
import { buryReportV2 } from "@/libs/business/account";

export default {
  name: "",
  props: ["isSuspend"],
  data() {
    return {
      appkey: "",
      user_id: "",
      bindVisible: false,
      giftVisible: false,
      realNameVisible: false,
      giftId: "",
      giftType: ""
    }
  },
  computed: {
    ...mapState({
      model: state => state.activity.activity_info,
      redDotList: state => state.activity.red_dot_list
    })
  },
  watch: {
    redDotList(val) {
      if (!val.length) {
        registHiddenRedDotFunction(null)
      }
    }
  },
  components: {
    Summary,
    Bind,
    Gift
  },
  methods: {
    redirectFloatPage(page) {
      if (!this.isSuspend) {
          openFloatBall(page);
        } else {
          this.$store.commit('suspend/CHANGE_STATE', { summaryVisible: false, sideBarVisible: true });
          const tabs = this.$store.state.suspend.tabs;
          const reRouteTab = tabs.find(item => item.type == page);
          if (reRouteTab && reRouteTab.show == true) {
            this.$store.commit('suspend/CHANGE_STATE', { activeTab: reRouteTab });
            this.reRouteReport(reRouteTab.type)
          }
        }
    },
    reRouteReport(type) {
      const uploadCache = this.$getStorage('buryport') || {};
      if (type === 'welfare') {
        buryReportV2('SDK_MENU_PROFIT', { menu_name: "福利", ...uploadCache })
      }
    },
    close() {
      if (this.isSuspend) {
        this.$store.commit('suspend/CHANGE_STATE', { summaryVisible: false, sideBarVisible: true });
      } else {
        const device_info = this.$getStorage('device_info');
        if (versionCompare(device_info.sdkVersion, '4.5.1')) {
          openFloatBall('geren');
        } else {
          registReturnGameFunction(null)
        }
      }
    },
    async showBind() {
      const telStatus = getStorage('tel_status');
      if (telStatus == 1) {
        this.$toast('当前账号已绑定手机');
        this.giftType = 1
        this.giftVisible = true;
        return;
      }

      this.bindVisible = true;
    },
    closeGift() {
      this.giftVisible = false;
    },
    showGift(item) {
      if (!item.gift_id) return;
      this.giftId = item.gift_id;
      this.giftType = 3
      setTimeout(() => {
        this.giftVisible = true;
      }, 1500);
    },
    async closeBind(bindSuccess) {
      this.bindVisible = false;
      if (bindSuccess) {
        this.giftType = 1
        this.giftVisible = true;
      }
    },
    closeRealName() {
      this.realNameVisible = false;
      this.maskVisible = false;
    }
  }
}
</script>

<style lang="scss" module>
.summary {
  width: 100%;
  height: 100%;
  .content {
    position: absolute;
    top: 0; 
    bottom: 0;
    left: 0;
    right: 0;
    width: 535px;
    height: 313px;
    margin: auto;
    @media screen and (orientation: portrait) {
      width: 353px;
      height: 275px;
    }
  }
  .bind {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 100;
  }
}
</style>